import { Component, Input, OnInit } from '@angular/core';
import { MessageHelper } from '../../../../core/helpers/message-helper';
import { StateHeadCompany } from '../../../models/head-company.model';
import { SharedService } from '../../../services/shared.service';

@Component({
    selector: 'app-head-company-section',
    templateUrl: './head-company-section.component.html',
    styleUrls: ['./head-company-section.component.scss'],
    standalone: false
})
export class HeadCompanySectionComponent implements OnInit {
  @Input() headCompany?: StateHeadCompany;
  
  constructor(private shared: SharedService) {

  }

  ngOnInit(): void {
  }
  
  get annualReturnFilingText(): string {
    return MessageHelper.GetTextForDayAndMonth(this.headCompany!.annualReturnFilingDay, 
      this.headCompany!.annualReturnFilingMonth);
  }
  get financialYearEndText(): string {
    return MessageHelper.GetTextForDayAndMonth(this.headCompany!.financialYearEndDay, 
      this.headCompany!.financialYearEndMonth);
  }

  public getCountryNameById(id: any): string {
    return this.shared.getCountryNameById(Number(id));
  }
}